// Copyright © 2021 Move Closer
import { defineComponent } from '@vue/composition-api';
import { bootstrapModalProps, useBootstrapModal } from './Modal.hooks';
/**
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 */
export const BootstrapModal = defineComponent({
    name: 'BootstrapModal',
    props: bootstrapModalProps,
    emits: ['close'],
    setup(props, ctx) {
        const { close, isDrawer } = useBootstrapModal(props, ctx);
        return { close, isDrawer };
    },
    template: `
    <div class="modal d-block" :class="[{ 'hidden': !open }, 'modal--mode-' + mode]" tabindex="-1" role="dialog" aria-label="Modal">
      <!-- Backdrop -->
      <div v-if="open" class="modal-backdrop fade show" @click="closable ? close() : null" />

      <!-- Actual modal -->
      <Transition :name="mode">
        <div v-if="open" class="modal-dialog">
          <slot v-bind:close="close" />
        </div>
      </Transition>
    </div>
  `
});
